import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusToolbarContainer], campus-toolbar-container',
})
export class ToolbarContainerDirective {
  @HostBinding('class.shared-toolbar__container')
  hasToolbarContainer = true;
}
